import { createContext, useContext, useRef, useState } from "react";
import { usePunditUserContext } from "@circle-react/contexts";

export const SupportWidgetContext = createContext<any>({});
SupportWidgetContext.displayName = "SupportWidgetContext";

export const useSupportWidgetContext = () => {
  const context = useContext(SupportWidgetContext);
  if (!context) {
    throw new Error(
      "useSupportWidgetContext must be used within a SupportWidgetContextProvider",
    );
  }
  return context;
};

export const SupportWidgetContextProvider = ({ children }: any) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();

  const onWidgetClose = useRef<(() => void) | null>(null);

  const [isOpen, setIsOpen] = useState(false);
  const toggleWidget = ({ shouldTriggerOnWidgetClose = false } = {}) => {
    if (isViewOnlyMasquerading) {
      return;
    }

    if (
      shouldTriggerOnWidgetClose &&
      isOpen &&
      onWidgetClose.current !== null
    ) {
      onWidgetClose.current();
    } else {
      setIsOpen(!isOpen);
    }
  };

  const openWidget = () => {
    setIsOpen(true);
  };

  return (
    <SupportWidgetContext.Provider
      value={{
        isOpen,
        toggleWidget,
        openWidget,
      }}
    >
      {children}
    </SupportWidgetContext.Provider>
  );
};
